export default "__VITE_ASSET__CIkE77_3__"